import React from 'react'

import { Box, Form, LoadingModule } from '@domain-group/suit-theme'

import useSelector from '@hooks/useSelector'

import usePriceListDisplayMode from '../../hooks/usePriceListDisplayMode'
import usePriceListManager from '../../hooks/usePriceListManager'

import Product from './Product'

interface PricingMatrixProps {
  loading: boolean,
  priceListManagerPayload: ReturnType<typeof usePriceListManager>,
}

const PricingMatrix = (props: PricingMatrixProps) => {
  const {
    loading,
    priceListManagerPayload: {
      assignedServiceProductIds,
      isMaster,
      providerPriceList,
    },
  } = props

  const { serviceProducts } = useSelector(reduxState => reduxState.entities)

  const {
    callbacks: {
      selectProductId,
    },
    selectedProductId,
    shouldUseDropDown,
  } = usePriceListDisplayMode({ assignedServiceProductIds, providerPriceList })

  if (loading){
    return <LoadingModule loading={loading} times={3} />
  }

  if (shouldUseDropDown){
    return (
      <Box flexDirection="column">
        <Box marginBottom="medium" padding="large" variant="white">
          <Form.Row>
            {/*
             // @ts-expect-error TS2322 */}
            <Form.Field label="Service Product" marginTop={['large', 0]}>
              <select
                onChange={((e: React.ChangeEvent<HTMLSelectElement>) => selectProductId(Number(e.target.value)))}
                value={selectedProductId || ''}
              >
                {assignedServiceProductIds.map(id => (
                  <option key={id} value={id}>
                    {serviceProducts[id]?.title || `Product ${id}`}
                  </option>
                ))}
              </select>
            </Form.Field>
          </Form.Row>
        </Box>

        {selectedProductId && (
          <Product
            isMaster={isMaster}
            key={selectedProductId}
            providerPriceList={providerPriceList}
            serviceProductId={selectedProductId}
          />
        )}
      </Box>
    )
  }

  return (
    <Box flexDirection="column">
      {assignedServiceProductIds.map(serviceProductId => (
        <Product
          isMaster={isMaster}
          key={serviceProductId}
          providerPriceList={providerPriceList}
          serviceProductId={serviceProductId}
        />
      ))}
    </Box>
  )
}

export default PricingMatrix
